import Vue from 'vue';
import VueRouter from 'vue-router';

import Home from '@/views/home/Home.vue';
import Products from '@/views/products/Products.vue';
import BehaviorDetail from '@/views/products/behavior/BehaviorDetail.vue';
import AnesthesiaDetail from '@/views/products/anesthesia/AnesthesiaDetail.vue';
import ConsumablesDetail from '@/views/products/consumables/ConsumablesDetail.vue';
import TreatmentDetail from '@/views/products/treatment/TreatmentDetail.vue';
import PathologyDetail from '@/views/products/pathology/PathologyDetail.vue';
import AssetDetail from '@/views/products/asset/AssetDetail.vue';

import Cases from '@/views/cases/Cases.vue';
import NationalChildDetail from '@/views/cases/national-child/NationalChildDetail.vue';
import RenjiDetail from '@/views/cases/renji/RenjiDetail.vue';
import WestChinaDetail from '@/views/cases/west-china/WestChinaDetail.vue';

import News from '@/views/news/News.vue';
import NewsDetail1 from '@/views/news/detail/NewsDetail1.vue';
import NewsDetail2 from '@/views/news/detail/NewsDetail2.vue';
import NewsDetail3 from '@/views/news/detail/NewsDetail3.vue';

import Contact from '@/views/contact/Contact.vue';

Vue.use(VueRouter);

const routes = [
  { path: '/', component: Home },
  { path: '/products', component: Products },
  { path: '/products/behavior', component: BehaviorDetail },
  { path: '/products/anesthesia', component: AnesthesiaDetail },
  { path: '/products/consumables', component: ConsumablesDetail },
  { path: '/products/treatment', component: TreatmentDetail },
  { path: '/products/pathology', component: PathologyDetail },
  { path: '/products/asset', component: AssetDetail },
  { path: '/cases', component: Cases },
  { path: '/cases/national-child', component: NationalChildDetail },
  { path: '/cases/renji', component: RenjiDetail },
  { path: '/cases/west-china', component: WestChinaDetail },
  { path: '/news', component: News },
  { path: '/news/1', component: NewsDetail1 },
  { path: '/news/2', component: NewsDetail2 },
  { path: '/news/3', component: NewsDetail3 },
  { path: '/contact', component: Contact }
];

const router = new VueRouter({
  mode: 'hash',
  routes
});

export default router;